type DiffSetsResult<T> = {
    added: Set<T>;
    removed: Set<T>;
    equal: Set<T>;
};

export function diffSets<T>(previous: Set<T>, current: Set<T>): DiffSetsResult<T> {
    const result: DiffSetsResult<T> = {
        added: new Set(),
        removed: new Set(),
        equal: new Set(),
    };

    for (const value of previous) {
        if (!current.has(value)) {
            result.removed.add(value);
        } else {
            result.equal.add(value);
        }
    }

    for (const value of current) {
        if (!previous.has(value)) {
            result.added.add(value);
        }
    }

    return result;
}
